import styled from '@emotion/styled';

export type IFundStatsType = 'operacional' | 'pre-operacional' | 'cancelado';

interface IFundStats {
  status: IFundStatsType | string;
}

interface ICheckChip {
  checked: boolean;
  maincolor?: string;
}

const getStatusColor = (props): string => {
  switch (props.status) {
    case 'operational':
      return props.theme.palette.operational.main;
    case 'pre-operational':
      return props.theme.palette.preOperational.main;
    case 'canceled':
      return props.theme.palette.canceled.main;
  }
};

const getCheckedColor = (props): string => {
  const { mediumNeutral } = props.theme.palette;
  const mainColor = props.maincolor || 'primary';

  return props.checked
    ? props.theme.palette[mainColor].main
    : mediumNeutral.main;
};

export const ChipBase = styled.li`
  padding: 4px 10px;
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  border-radius: 5px;
  margin: 0 10px 10px 0;
  text-transform: uppercase;
`;

export const CheckChip = styled(ChipBase)<ICheckChip>`
  color: ${(props) => getCheckedColor(props)};
  border: solid 1px ${(props) => getCheckedColor(props)};

  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FundStatusChip = styled(ChipBase)<IFundStats>`
  color: ${(props) => getStatusColor(props)};
  border: solid 1px ${(props) => getStatusColor(props)};

  display: flex;
  flex-direction: row;
  align-items: center;
`;
